import styled from 'styled-components';
import { FontSizes } from '@uifabric/fluent-theme';

export const Header = styled.div`
  font-size: ${FontSizes.size16};
  margin-bottom: 20px;
`;
